
<div class="view-component">
    <div class="view-component-title">
        <span class="title">Integração de Pagamentos</span>
    </div>
    <div class="content">
        <div class="tabcontent">
            <mat-tab-group ngClass="custom-tabs" (selectedTabChange)="onTabChanged($event);" mat-stretch-tabs="false" mat-align-tabs="start">
                <mat-tab id="Mktppayments"> 
                    <ng-template mat-tab-label>
                        Detalhes
                    </ng-template>
                    <div class="mktplace">
                        <simple-datagrid entityName="Mktppayments" [parentRow]="parentRow" condition="0=0" [events]="eventsSubject.asObservable()"></simple-datagrid>
                    </div>
                </mat-tab>
            </mat-tab-group>
        </div>
    </div>
</div> 